module.exports = __webpack_public_path__ + "static/media/A-sharp-7ths.2a1b8ab5.png";